import {Tooltip} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";
import {CheckCircleOutlined, HighlightOff} from "@mui/icons-material";
import React, {FC, ReactElement} from "react";
import Box from "@mui/material/Box";
import {validatePassword} from "../../../util/regex";

interface IProps {
    children: ReactElement<any, any>
    open: boolean
    value: string
}

const PasswordValidationTooltip: FC<IProps> = ({children, open, value}) => {
    const {t} = useTranslation()

    const getListItem = (label: string, regex: RegExp) => {
        const isValid = regex.test(value)
        return <li style={{marginBlock: '0.5em'}}>
            <Typography variant='body2'
                        className="notranslate"
                        sx={{display: 'flex', alignItems: 'center', gap: '0.5em'}}>
                {isValid ? <CheckCircleOutlined fontSize="small" color="success"/> :
                    <HighlightOff fontSize="small" color="error"/>}
                {label}
            </Typography>
        </li>
    }

    return (
        <Tooltip open={open && !validatePassword(value)} enterTouchDelay={0} title={
            <Box p={1}>
                <Typography variant="subtitle1" fontWeight={600}>{t('requirements')}</Typography>
                <ul style={{paddingInlineStart: '0', listStyleType: 'none'}}>
                    {getListItem(t('eight_characters'), /^.{8,}$/)}
                    {getListItem(t('include_lowercase'), /[a-z]/)}
                    {getListItem(t('include_uppercase'), /[A-Z]/)}
                    {getListItem(`${t('include_special')} !#$%&'()*+,-./:;<?=@>[]^_\`{|}~`, /[!#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/)}
                </ul>
            </Box>
        } arrow placement="top">
            {children}
        </Tooltip>
    );
}

export default PasswordValidationTooltip;
